module.exports = __webpack_public_path__ + "static/media/avatar.364fb38b.svg";